import { Select } from '@chakra-ui/react';
import {
  EmailConfigType,
  emailConfigTypeMetadata,
  SiteCode,
} from '@snap-types/models/enums';
import { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import { UpdateTeamWithConfig } from '@snap-types/models/team';
import { objectKeysTyped } from '@snap-types/util/object-iterators';
import { useFormContext } from 'react-hook-form';

export function TeamEmailConfigSelect({
  team,
  index,
}: {
  team: UpdateTeamWithConfig;
  index: number;
}) {
  const form = useFormContext<SnapSiteConfigEditFormDataUnvalidated>();

  const emailConfigOptions = objectKeysTyped(EmailConfigType)
    .map((emailConfigType) => {
      if (
        emailConfigTypeMetadata[emailConfigType].limitedToSites === null ||
        emailConfigTypeMetadata[emailConfigType].limitedToSites?.includes(
          form.getValues('site.code') as SiteCode,
        )
      ) {
        return {
          emailConfigType,
          ...emailConfigTypeMetadata[emailConfigType],
        };
      }
      return null;
    })
    .filter((emailConfigType) => emailConfigType !== null);

  return (
    <Select
      {...form.register(
        `site.teams.${index}.currentTeamConfig.quoteEmailSettings`,
      )}
      id={`${team.teamCode}-email-select`}
    >
      {emailConfigOptions.map((emailConfigType) => (
        <option
          key={emailConfigType.emailConfigType}
          value={emailConfigType.emailConfigType}
        >
          {emailConfigType.name}
        </option>
      ))}
    </Select>
  );
}
